import isDefined from './isDefined';
export default function isNotDefined(value) {
    return !isDefined(value);
}
